export default {
  namespaced: true,
  state: {
    isPc: sessionStorage.getItem('isPc')
      ? JSON.parse(sessionStorage.getItem('isPc'))
      : false
  },
  mutations: {
    fetch(state, isPc) {
      state.isPc = isPc
      sessionStorage.setItem('isPc', JSON.stringify(isPc))
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    fetch({ commit, state }) {
      let userAgentInfo = navigator.userAgent
      let Agents = new Array(
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
        'BlackBerry',
        'webOS'
      )
      let flag = true
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false
          break
        }
      }
      commit('fetch', flag)
    }
  },
  getters: {
    isPc: state => {
      return state.isPc
    }
  }
}
